export default __webpack_public_path__ + "static/media/btn-mergado-store.d17f2af9.svg";